<template>
    <div class="text-popover">

        <b-badge size="sm" pill :variant="variant" class="px-2 py-1"
                 :id="`pop-${id}`">
            ...
        </b-badge>
        <b-popover triggers="hover"
                   :target="`pop-${id}`">
            <slot/>
        </b-popover>

    </div>
</template>

<script>
import Vue from 'vue'

/**
 * Badge with popover for displaying a block of text.
 */
export default Vue.extend({
    name: 'TextPopover',
    props: {
        id: String,
        variant: String
    }
})
</script>
